export const EMAIL_ERROR_MESSAGE = $localize`Please enter a valid email address (for example: your.name@domain.com)`;
export const PHONE_ERROR_MESSAGE = $localize`Please check your dialing code and enter a valid phone number.`;
export const DEFAULT_ERROR_MESSAGE = $localize`This question is required`;
